module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO ORIGINAL GOOGLE-5e02740f2690d8fe391f41a09b2ff6a6.png";